import { c as _c } from "react/compiler-runtime";
import { OutpostDestination } from '../../../../../../../typings/outpost';
import Button from '../../../common/base/Button';
import { StyledCardSection } from '../../../common/base/Card';
import Text from '../../../common/base/Text';
import Dropdown from '../../../common/Dropdown';
import { Div } from '../../../common/helpers/StyledUtils';
import { PreviewBucket } from '../../../common/Histogram/PreviewHistogram';
import PreviewHistogram from '../../../common/Histogram/PreviewHistogram';
type Props = {
  data_2h_sample: PreviewBucket[];
  data_4h_sample: PreviewBucket[];
  destination: OutpostDestination;
};
const dimensions_config = {
  success: {
    color: 'green_histogram',
    label: 'Succeeded'
  },
  failed: {
    color: 'red_histogram',
    label: 'Failed'
  }
} as const;
const DestinationMetricsPreview = t0 => {
  const $ = _c(17);
  const {
    data_2h_sample,
    data_4h_sample,
    destination
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      px: 72
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== data_4h_sample) {
    t2 = (opened, toggle) => <Button ghost={true} active={opened} p={1.5} w={100} onClick={e_0 => {
      e_0.stopPropagation();
      toggle(!opened);
    }}><PreviewHistogram size="small" values={data_4h_sample} dimensions_config={dimensions_config} resolution="hour" /></Button>;
    $[1] = data_4h_sample;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      px: 382
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      b: 2
    };
    t5 = <Text size="s" semi={true}>Deliveries</Text>;
    $[4] = t4;
    $[5] = t5;
  } else {
    t4 = $[4];
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Div flex={true} m={t4}>{t5}<Text size="s" semi={true} muted={true} m={{
        x: 1
      }}>{" \xB7 "}</Text><Text size="s" semi={true} neutral={true}>Last 24h</Text></Div>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== data_2h_sample) {
    t7 = <StyledCardSection p={4} w={t3}>{t6}<PreviewHistogram values={data_2h_sample} resolution="hour" dimensions_config={dimensions_config} show_tooltip={true} size="medium" /></StyledCardSection>;
    $[7] = data_2h_sample;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      x: 4,
      y: 3
    };
    t9 = {
      justify: "flex-end"
    };
    $[9] = t8;
    $[10] = t9;
  } else {
    t8 = $[9];
    t9 = $[10];
  }
  const t10 = `/event-deliveries?destination_id=${destination.id}`;
  let t11;
  if ($[11] !== t10) {
    t11 = <StyledCardSection p={t8} flex={t9}><Button outline={true} to={t10} icon="link">View all deliveries</Button></StyledCardSection>;
    $[11] = t10;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] !== t11 || $[14] !== t2 || $[15] !== t7) {
    t12 = <Div w={t1} onClick={_temp}><Dropdown placement="bottom-end" portal={true} renderToggle={t2}>{t7}{t11}</Dropdown></Div>;
    $[13] = t11;
    $[14] = t2;
    $[15] = t7;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  return t12;
};
export default DestinationMetricsPreview;
function _temp(e) {
  return e.stopPropagation();
}